import React, { Component } from "react";
import "./assets/footer.scss";
import helpmindlogo from "./assets/helpmindlogo.png";
import Quote from "./Quote";

export default class Footer extends Component {
  render() {
    return (
      <div className="container-fluid">
        <Quote />
        <footer className="container-fluid mt-auto">
          <div className="row">
            <div className="footer-primary container">
              <div className="row justify-content-md-center text-center">

                <div className="col col-lg-3 col-sm-6">
                  <h3 className="h6 text-white mb-3">About</h3>
                  <div className="list-group list-group-flush list-group-transparent">
                    <a className="list-group-item list-group-item-action" href="/about">Who Are We</a>
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                  </div>
                </div>

                <div className="col col-lg-3 col-sm-6">
                  <h3 className="h6 text-white mb-3">Company</h3>

                  <div className="list-group list-group-flush list-group-transparent">
                    <a className="list-group-item list-group-item-action" href="#">Contact Us</a>
                    <a className="list-group-item list-group-item-action" href="#">Help</a>
                    <a className="list-group-item list-group-item-action" href="#">Careers</a>
                    <a className="list-group-item list-group-item-action" href="#">Terms &amp; Conditions</a>
                    <a className="list-group-item list-group-item-action" href="#">Privacy &amp; Policy</a>
                  </div>
                </div>

                <div className="col col-lg-3 col-sm-6">
                  <h3 className="h6 text-white mb-3">Resources</h3>

                  <div className="list-group list-group-flush list-group-transparent">
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                    <a className="list-group-item list-group-item-action" href="#">Example</a>
                  </div>
                </div>

                <div className="col col-lg-3 col-sm-6">
                  <h3 className="h6 text-white mb-3">Social</h3>

                  <div className="list-group list-group-flush list-group-transparent">
                    <a className="list-group-item list-group-item-action" href="#">
                      <span className="fab fa-facebook-f min-width-3 text-center mr-2"></span>
                      Facebook
                    </a>
                    <a className="list-group-item list-group-item-action" href="#">
                      <span className="fab fa-twitter min-width-3 text-center mr-2"></span>
                      Twitter
                    </a>
                    <a className="list-group-item list-group-item-action" href="#">
                      <span className="fab fa-gitlab min-width-3 text-center mr-2"></span>
                      GitLab
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="row">
            <div className="footer-secondary container-fluid">
              <div className="row">
                <div className="col">
                  <div className="mx-auto text-center">
                    <img className="logo" src={helpmindlogo} alt="help my mind" /><span>HELP MY MIND</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/footer/Footer.js